import { createFileRoute, notFound } from '@tanstack/react-router'

import { Stack } from '@masterplandev/ui'

import { CompanyPage } from '@/app/manager/CompanyPage/CompanyPage'
import { PageContainer } from '@/app/manager/Layout'
import { AuditLogForm } from '@/audit-log/components/AuditLogForm/AuditLogForm'
import { AuditLogHeading } from '@/audit-log/components/AuditLogHeading/AuditLogHeading'
import { FEATURE_AUDIT_LOG } from '@/core/constants/features'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'

export const Route = createFileRoute('/company/_management/audit-log')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-audit-log',
        }),
      },
    ],
  }),
  beforeLoad: ({ context }) => {
    if (!context.user?.features.includes(FEATURE_AUDIT_LOG)) {
      throw notFound()
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CompanyPage>
      <PageContainer py="10">
        <Stack spacing="10">
          <AuditLogHeading />
          <AuditLogForm />
        </Stack>
      </PageContainer>
    </CompanyPage>
  )
}
